import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ContactUs } from '../../models/contactUs';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-contactus',
  imports: [CommonModule, FormsModule],
  templateUrl: './contactus.component.html',
  styleUrl: './contactus.component.css'
})
export class ContactusComponent {
  showCreatorForm: boolean = false;
  disableSubmit: boolean = false;
  showPostSubmitMessage: boolean = false;

  model: ContactUs = {
    name: '',
    email: '',
    handle: '',
    message: ''
  };

  constructor(public http: HttpClient) {}

  submit() {
    this.disableSubmit = true;
    this.showPostSubmitMessage = true;
    const jsonString = JSON.stringify(this.model);
    const encodedEmail = btoa(jsonString);
    this.http.post(`${environment.apiUrl}contactUsPost`, { email: encodedEmail }).subscribe((response) => {
      console.log(response);
    });
  }
}
